// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EwMGv","col":"styles_col__2ESr5"};